import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/security/LoginPage'
import ChangePasswordPage from '@/pages/security/ChangePasswordPage'
import SQLWorkbenchPage from '@/pages/SQLWorkbenchPage'
import FileSystemPage from '@/pages/FileSystemPage'
import IconsPage from '@/pages/IconsPage'
import AboutPage from '@/pages/AboutPage'

Vue.use(Router)
/**
 * By default the page are public, to secure a page, add the secure property with a value of true as part of the meta property
 *
 * meta: {
 *   secure: false
 * }
 */
export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/user/password',
      name: 'ChangePasswordPage',
      component: ChangePasswordPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/workbench',
      name: 'SQLWorkbenchPage',
      component: SQLWorkbenchPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/filesystem',
      name: 'FileSystemPage',
      component: FileSystemPage,
      meta: {
        secure: true
      }
    },
    {
      path: '/icons',
      name: 'IconsPage',
      component: IconsPage
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js